import MetricDown from './MetricDown';

export default MetricDown;